export default (props, vars) => () =>
  vars?.['usestate1isopen']?.['setState']((o) => !o);
